module.exports = __webpack_public_path__ + "static/media/Birchs in winter.98ddea9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Eide/Birchs in winter.jpg
// module id = 511
// module chunks = 0